type AdminSectionPageProps = {
  eyebrow: string;
  title: string;
  description: string;
  bullets: string[];
};

export function AdminSectionPage({ eyebrow, title, description, bullets }: AdminSectionPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm uppercase tracking-[0.2em] text-cyan-300">{eyebrow}</p>
        <h1 className="mt-3 text-4xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-4 max-w-3xl text-slate-300">{description}</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {bullets.map((item) => (
          <div className="rounded-3xl border border-white/10 bg-white/5 p-5 text-sm leading-7 text-slate-300" key={item}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
